import * as React from 'react';
import { Button } from 'reactstrap';
import { useState } from 'react';
import { Communicator } from '../../tools/Communication';
import { toCsvBlob } from '@/utils/data';
import { download } from '@/utils/download';
import i18n from '@/utils/i18n';
import { ContentSection } from '../../components/Layout/ContentSection';

export default function AddContainerCollectionsView() {
  const [count, setCount] = useState('0');
  const [isLoading, setIsLoading] = useState(false);

  async function addContainerCollections() {
    setIsLoading(true);
    const result = await Communicator.PostData(
      '/api/3/ContainerCollection/Add',
      count,
    );
    if (result.status !== 200) {
      setIsLoading(false);
      const res = await result.json();
      alert(JSON.stringify(res));
      return;
    }
    const ids = await result.json();
    const obj = ids.map((id: string) => ({ id }));
    const blob = toCsvBlob(obj);
    download(
      blob,
      `container_collections_${new Date(Date.now())
        .toISOString()
        .substring(0, 10)}.csv`,
    );
    setIsLoading(false);
  }

  return (
    <ContentSection title="Add Container collections" collapsable={false}>
      <div className="input-group mb-3">
        <span className="input-group-text" id="basic-addon1">
          {i18n.t('ContainerCollection:count')}
        </span>
        <input
          className="form-control"
          value={count}
          onChange={(e) => setCount(e.target.value.replace(/[^0-9]/g, ''))}
        />
      </div>
      <Button color="primary" size="sm" onClick={addContainerCollections}>
        {isLoading ? i18n.t('Common:adding') : i18n.t('Common:add')}
      </Button>
    </ContentSection>
  );
}
